import { GET, POST } from "@/services/request";
import * as APIs from '@/services/APIs';

/**
 * 兑换管理中获取优惠券列表
 */
export const fetchTicketList = async () => {
    const res = await GET(APIs.API_TICKET_COUPONSLIST);

    return res.data.data ?? {};
};


/**
 * 兑换管理中获取优惠券列表
 */
export const fetchTicketActList = async () => {
    const res = await GET(APIs.API_TICKET_TICKETACTLIST);

    return res.data.data ?? {};
};

/**
 * 可兑换卡券列表
 */
export const fetchConvertTicket = async (params) => {
    const res = await GET(APIs.API_TICKET_CONVERTTICKET, { params });

    return res.data.data ?? {};
};

/**
 * 活动发券列表
 */
export const fetchActList = async (params) => {
    const res = await GET(APIs.API_TICKET_ACTLIST, { params });

    return res.data.data ?? {};
};

/**
 * 已兑换或已过期卡券列表
 */
export const fetchUseTicketList = async (params) => {
    const res = await GET(APIs.API_TICKET_USETICKET, { params });

    return res.data.data ?? {};
};

/**
 * 兑换
 */
export const fetchExchangeTicket = async (data) => {
    const res = await POST(APIs.API_TICKET_EXCHANGETICKET, { data });

    return res.data ?? {};
};

/**
 * 扫二维码兑换
 */
export const fetchQrcodeExchangeTicket = async (data) => {
    const res = await POST(APIs.API_TICKET_QRCODEEXCHANGETICKET, { data });

    return res.data ?? {};
};

/**
 * 发券
 */
export const fetchSendTicket = async (act_member_id) => {
    const res = await GET(APIs.API_TICKET_SENDTICKET, { params: { act_member_id } });

    return res.data ?? {};
};

/**
 * 补券
 */
export const fetchRepairTicket = async (data) => {
    const res = await POST(APIs.API_TICKET_REPAIRTICKET, { data });

    return res.data ?? {};
};